import React, {useRef, useEffect, useState, useLayoutEffect} from "react";
import './menu.scss';
import {useTranslation} from 'gatsby-plugin-react-i18next';
import {setTrap} from "../../utils/trap-focus";
import TransitionLink from "gatsby-plugin-transition-link/"
import {Link} from "gatsby";

// Defining the <Greeting> component
export const Menu = (props) => {
  let lang = props.language;
  let data = props.data;

  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);

  let isChina = props.language === "zh_hans" ||  props.language === "zh_hant" ? true : false;
  let isChinaOnly = props.language === "zh_hans" ? true : false;


  const { t } = useTranslation();
  const hideChangeLanguage = data['hideChangeLanguage'] === 'true';

  const menuRef = useRef(null);
  useLayoutEffect(() => {
    if(open) {
      setTrap(menuRef.current);
    }
  }, [open])

  const modal = useRef(null);
  setTrap(modal.current);

  if(typeof window !== 'undefined'){
    if(window.innerWidth <= 1024){
      let vh = typeof window !== 'undefined' ? window.innerHeight * 0.01 : 0;
      if(typeof document !== 'undefined' ){
        document.body.style.setProperty('--vh', `${vh}px`);
      }
      window.addEventListener('resize', () => {
        let vh = typeof window !== 'undefined' ? window.innerHeight * 0.01 : 0;
        if(typeof document !== 'undefined' ){
          document.body.style.setProperty('--vh', `${vh}px`);
        }
      })
    }  
  }
  
  


  let link =  '/';

  let location = typeof window !== "undefined" ? window.location : '';
  let title = typeof document !== "undefined" ? document.title : '';
  
  useEffect(() => {
    setOpen(props.open);
    if(open){
      document.body.classList.add('blockScroll');


    }else {
      document.body.classList.remove('blockScroll');
    }
    if(!visible){
      setTrap(menuRef.current);
     }
  });

  function exitAnim(){
    document.body.classList.add('glitch-anim');
    document.body.classList.remove('entry-anim')
  }

  function entryAnim(){
    document.body.classList.remove('glitch-anim');
    
  }
  


  let toggleOverlay = (isShowing) => {
    setVisible(isShowing);
    let action = isShowing ? 'add' : 'remove';
    //if((typeof window !== "undefined")){
      document.getElementsByTagName('body')[0].classList[action]('openOverlay');
      document.body.classList[action]('blockScroll');
   // }
  };

  function closeAll(){
    toggleOverlay(false);
    props.closeMenu();
  }
  
  return (
    <div className={"menu" + (open ? ' menu--open' : '')} ref={menuRef}>
      <div className="menu__cont" >
        <div className="menu__aux">
        <nav className="menu__nav">
          <ul className="menu__voices">
            <li className="menu__voice " >
            <TransitionLink className = "menu__link j-voice" 
              onClick={props.closeMenu}
              exit={{
                length: 0.8,
                trigger: ({ exit, node }) =>  exitAnim(exit, node),
        
              }}
              entry={{
                delay: 0.8,
                trigger: ({ entry, node }) =>  entryAnim(entry, node),
              }}
              to={ "/" + lang + "/"} 
                >
                {data['Home']}
              </TransitionLink>
            </li>
            <li>
            <TransitionLink  className = "menu__link j-voice" 
              onClick={props.closeMenu}
              exit={{
                length: 0.8,
                trigger: ({ exit, node }) =>  exitAnim(exit, node),
        
              }}
              entry={{
                delay: 0.8,
                trigger: ({ entry, node }) =>  entryAnim(entry, node),
              }}
              to={ "/" + lang + "/collection"}  >
                {data['Collection']} 
                </TransitionLink>
            </li>
            <li className="menu__voice ">
            <TransitionLink  className = "menu__link j-voice" 
              onClick={props.closeMenu}
              exit={{
                length: 0.8,
                trigger: ({ exit, node }) =>  exitAnim(exit, node),
        
              }}
              entry={{
                delay: 0.8,
                trigger: ({ entry, node }) =>  entryAnim(entry, node),
              }}
              to={ "/" + lang + "/products"}  >
                {data['All items']} 
                </TransitionLink>
            </li>
            {
              !isChinaOnly && 
              <li className="menu__voice ">
                <TransitionLink  className = "menu__link j-voice" 
                  onClick={props.closeMenu}
                  exit={{
                    length: 0.8,
                    trigger: ({ exit, node }) =>  exitAnim(exit, node),

                  }}
                  entry={{
                    delay: 0.8,
                    trigger: ({ entry, node }) =>  entryAnim(entry, node),
                  }} to={ "/" + lang + "/loro-piana"}>
                    {data['Capsule']} 
                  </TransitionLink>
              </li>
            }
            {
              !isChinaOnly && 
              <li className="menu__voice ">
                          <TransitionLink  className = "menu__link j-voice" 
                onClick={props.closeMenu}
                exit={{
                  length: 0.8,
                  trigger: ({ exit, node }) =>  exitAnim(exit, node),
          
                }}
                entry={{
                  delay: 0.8,
                  trigger: ({ entry, node }) =>  entryAnim(entry, node),
                }} to={ "/" + lang + "/capsule"}>
                  {data['Subscribe button']} 
                </TransitionLink>
                
              </li>
              }
            <li className="menu__voice ">
                        <TransitionLink  className = "menu__link j-voice" 
              onClick={props.closeMenu}
              exit={{
                length: 0.8,
                trigger: ({ exit, node }) =>  exitAnim(exit, node),
        
              }}
              entry={{
                delay: 0.8,
                trigger: ({ entry, node }) =>  entryAnim(entry, node),
              }} to={ "/" + lang + "/the-designer"}>
                {data['The designer']} 
                </TransitionLink>
            </li>
            <li className="menu__voice ">
            <TransitionLink  className = "menu__link j-voice" 
              onClick={props.closeMenu}
              exit={{
                length: 0.8,
                trigger: ({ exit, node }) =>  exitAnim(exit, node),
        
              }}
              entry={{
                delay: 0.8,
                trigger: ({ entry, node }) =>  entryAnim(entry, node),
              }} to={ "/" + lang + "/stores"}>
                {data['Stores']} 
                </TransitionLink>
            </li>
          </ul>
        </nav>
        {/* <button className="menu__linkExt" > */}
        <a href={data['urlLoroPiana']} className="menu__linkExt">
        {data['Visit LoroPiana']}
        </a>
        {/* </button> */}
        <a href={data['privacy text']} target="_blank" className="menu__modal" >
        {data['privacy label']}
        </a>
        {
          !hideChangeLanguage && 
            <button className="menu__modal" onClick={() => toggleOverlay(true)} >
            {data['change language']}
            </button>
        }
        
        {
          !isChina && 
          <span className="menu__share">
          {data['share on']}
          </span>
        }
        
        {
          !isChina && 
          
          <div className="menu__socials">
            <div className="menu__social " aria-label={data['shareFB']} >
              <a target="_blank" 
                  href={`https://www.facebook.com/sharer/sharer.php?u=${location}&amp;src=sdkpreparse`}
                  className="share__link i-FB"  aria-label={data['shareFB']} ></a>
            </div>
            <div className="menu__social" aria-label='instagram link' >
            <a target="_blank" 
                  href={`https://www.instagram.com/loropianaofficial`}
                  className="share__link i-instagram" aria-label='instagram link' ></a>
            </div>
            <div className="menu__social " aria-label={data['shareLinkedin']} >
            <a target="_blank" 
                  href={`https://www.linkedin.com/company/loro-piana`}
                  className="share__link i-linkedin" aria-label={data['shareLinkedin']} ></a>
            </div>
            <div className="menu__social " aria-label={data['shareTwitter']} >
              <a target="_blank" 
                    href={`http://www.twitter.com/share?url=${location}`}
                    className="share__link i-twitter" aria-label={data['shareTwitter']} ></a>
            </div>
          </div>
        }
         
          
        </div>
        <button className="menu__close i-close" onClick={props.closeMenu} aria-label={`${t('close')}`} >
        </button>
      </div>
      {
        visible &&
        <div className={`${visible ? '' : 'overlayWrapper--hidden'} overlayWrapper`}>
            <div className="overlay" ref={modal}>
              <a href="#" className="overlay__close" onClick={() => closeAll()} tabIndex={`${visible  ? '0' : '-1'}`}>
                <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="30.4144" y="29" width="20" height="2" rx="1" transform="rotate(45 30.4144 29)" fill="black"/>
                  <rect x="29.4144" y="43.1421" width="20" height="2" rx="1" transform="rotate(-45 29.4144 43.1421)" fill="black"/>
                </svg>
                <span className="overlay__closeLabel" >{data['close']}</span>
              </a>
              <div className="overlay__content">
                <h3 className="overlay__title">
                {data['change language']}
                </h3>
                <ul className="regionList__langList">
                        <li className="langList__item">
                          <Link to="/en/"  language="en" className="langList__link" onClick={() => closeAll()} tabIndex={`${visible  ? '0' : '-1'}`}>
                          {data['English']}
                          </Link>
                        </li>
                        <li className="langList__item">
                          <a href={`https://www.loropiana.cn/hiroshifujiwara/zh_hans${link}`} onClick={() => closeAll()} className="langList__link" tabIndex={`${visible  ? '0' : '-1'}`}>
                          {data['chinese_SIMPLIFIED']}
                
                          </a>
                        </li>
                        <li className="langList__item">
                          <Link to='/zh_hant/' language="zh_hant" className="langList__link" onClick={() => closeAll()} tabIndex={`${visible  ? '0' : '-1'}`}>
                            
                          {data['CHINESE_TRADITIONAL']}
                          </Link>
                        </li>
                        <li className="langList__item">
                          <Link to='/fr/' language="fr" className="langList__link" onClick={() => closeAll()} tabIndex={`${visible  ? '0' : '-1'}`}>
                          {data['French']}
                          </Link>
                        </li>
                        <li className="langList__item">
                          <Link to='/de/' language="de" className="langList__link" onClick={() => closeAll()} tabIndex={`${visible  ? '0' : '-1'}`}>
                          {data['German']}
                          </Link>
                        </li>
                        <li className="langList__item">
                          <Link to='/it/' language="it" className="langList__link" onClick={() => closeAll()} tabIndex={`${visible  ? '0' : '-1'}`}>
                          {data['Italian']}
                          </Link>
                        </li>
                        
                        <li className="langList__item">
                          <Link to='/ja/' language="ja" className="langList__link" onClick={() => closeAll()} tabIndex={`${visible  ? '0' : '-1'}`}>
                          {data['Japanese']}
                          </Link>
                        </li>
                        <li className="langList__item">
                          <Link to='/ko/' language="ko" className="langList__link" onClick={() => closeAll()} tabIndex={`${visible  ? '0' : '-1'}`}>
                          {data['Korean']}
                          </Link>
                        </li>
                        <li className="langList__item">
                          <Link to="/ru/" language="ru" className="langList__link" onClick={() => closeAll()} tabIndex={`${visible  ? '0' : '-1'}`}>
                          {data['Russian']}
                          </Link>
                        </li>
                      </ul>
              </div>
            </div>
      </div>
      }
    </div>
    )
  }